import { utils } from '@febos-io/common';
import * as types from './types';
import { actions } from './reducer';

export * from './actions_ts';

export const setPatients = (patients) => utils.createActionCreator(
  types.SET_LIST_PATIENTS,
  patients,
  actions
);
export const setConfigurations = ({ companyId, configurations, }) => utils.createActionCreator(
  types.SET_CONFIGURATIONS,
  {
    companyId,
    configurations,
  },
  actions
);
export const setUsers = ({ companyId, filter, users, }) => utils.createActionCreator(
  types.SET_LIST_USERS,
  { companyId, filter, users, },
  actions
);

export const setSchedulers = ({ companyId, locationId, shedulers, }) => utils.createActionCreator(
  types.SET_LIST_SCHEDULERS,
  { companyId, locationId, shedulers, },
  actions
);
export const setAppointments = ({
  companyId,
  locationId,
  appointments,
}) => utils.createActionCreator(
  types.SET_LIST_APPOINTMENTS,
  { companyId, locationId, appointments, },
  actions
);

export const setExams = ({ companyId, exams, }) => utils.createActionCreator(
  types.SET_LIST_EXAMS,
  { companyId, exams, },
  actions
);
export const setClinics = ({ companyId, clinics, }) => utils.createActionCreator(
  types.SET_LIST_CLINICS,
  { companyId, clinics, },
  actions
);

export const setClinicsDentistList = ({ companyId, clinicId = '0', dentists, }) => utils.createActionCreator(
  types.SET_LIST_CLINICS_DENTISTS,
  { companyId, clinicId, dentists, },
  actions
);

export const setLoadingClinics = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING_CLINICS,
    loading,
    actions
  )
);

export const setLastClinic = (companyId, clinicId) => (
  utils.createActionCreator(
    types.SET_LAST_CLINICS,
    { companyId, clinicId, },
    actions
  )
);
export const setLoadingUsers = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING_COMPANY_USERS,
    loading,
    actions
  )
);

export const setLoadingScheduler = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING_SCHEDULERS,
    loading,
    actions
  )
);
export const setLoadingAppointments = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING_APPOINTMENTS,
    loading,
    actions
  )
);
export const setLoadingReserveAppointment = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING_RESERVE_APPOINTMENTS,
    loading,
    actions
  )
);
export const setAppointment = ({
  appointment,
}) => utils.createActionCreator(
  types.SET_APPOINTMENT,
  { appointment, },
  actions
);
export const setLoadingExams = (loading) => utils.createActionCreator(
  types.SET_LOADING_EXAMS,
  { loading, },
  actions
);
export const setLoadingPatients = (loading) => utils.createActionCreator(
  types.SET_LOADING_PATIENTS,
  { loading, },
  actions
);

export const handleLoadClinics = (companyId) => utils.createActionCreator(
  types.HANDLE_LOAD_COMPANY_CLINICS,
  { companyId, },
  actions
);
export const handleLoadCompanyUsers = (companyId, filter = '') => utils.createActionCreator(
  types.HANDLE_LOAD_COMPANY_USERS,
  { companyId, filter, },
  actions
);
export const handleLoadExams = (companyId) => utils.createActionCreator(
  types.HANDLE_LOAD_EXAMS,
  { companyId, },
  actions
);
export const setSchedulerStates = ({ companyId, schedulerStates, }) => utils.createActionCreator(
  types.SET_LIST_SCHEDULER_STATES,
  { companyId, schedulerStates, },
  actions
);

export const setLoadingSchedulerStates = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING_SCHEDULER_STATES,
    loading,
    actions
  )
);
export const setLoadingPutAppointmentStatus = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING_PUT_APPOINTMENT_STATUS,
    loading,
    actions
  )
);

export const setSchedulerState = ({ companyId, schedulerState, }) => utils.createActionCreator(
  types.SET_SCHEDULER_STATE,
  { companyId, schedulerState, },
  actions
);

export const removeSchedulerState = ({ companyId, statusId, }) => utils.createActionCreator(
  types.REMOVE_SCHEDULER_STATE,
  { companyId, statusId, },
  actions
);

export const handleCleanOldAppointments = ({
  companyId,
  locationId,
  monthsBack,
}) => utils.createActionCreator(
  types.HANDLE_CLEAN_OLD_APPOINTMENTS,
  {
    companyId,
    locationId,
    monthsBack,
  },
  actions
);

export const setCleanAppointmentsResult = ({
  companyId,
  locationId,
  cleanedCount,
  remainingCount,
}) => utils.createActionCreator(
  types.SET_CLEAN_APPOINTMENTS_RESULT,
  {
    companyId,
    locationId,
    cleanedCount,
    remainingCount,
  },
  actions
);
export const setPendingFiles = ({ clinicId, files, }) => utils.createActionCreator(
  types.SET_PENDING_FILES,
  { clinicId, files, },
  actions
);

export const clearPendingFiles = ({ clinicId, }) => utils.createActionCreator(
  types.CLEAR_PENDING_FILES,
  { clinicId, },
  actions
);

export const setPendingFile = ({ clinicId, fileId, file, }) => utils.createActionCreator(
  types.SET_PENDING_FILE,
  { clinicId, fileId, file, },
  actions
);
export const setSelectedPatient = (patient) => utils.createActionCreator(
  types.SET_SELECTED_PATIENT,
  patient,
  actions
);
